import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "consultation-actions" }
const _hoisted_2 = ["open"]
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = ["disabled"]

import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';
import CancelConsultationDialog from './CancelConsultationDialog.vue';
import RescheduleDialog from './RescheduleDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConsultationActions',
  props: {
    detail: {}
  },
  setup(__props: any) {

const props = __props;

const cancelOpen = ref(false);
const rescheduleOpen = ref(false);
const noShowOpen = ref(false);
const noShowActor = ref<'mentor' | 'mentee'>('mentee');
const noShowNotes = ref('');
const busy = ref(false);

// V2 hard cutover: the generic-admin record is now an OrderItem
// (OrderItem.public_id), not a ConsultationBooking. The detail id is the
// canonical orderItemId the V2 admin actions resolve.
const orderItemId = (): string => String(props.detail.id);

async function submitNoShow(): Promise<void> {
    busy.value = true;
    try {
        // TODO(v2-cutover): the /admin-api/consultation-bookings/<id>/mark-no-show/
        // endpoint was removed with the ConsultationBooking model. Re-point at the
        // V2 admin Conference no-show action (BespokeConferencesViewSet sets
        // Conference.status = NO_SHOW_MENTOR/MENTEE) resolved from the OrderItem,
        // i.e. POST /admin-api/conferences/<conference_id>/mark-no-show/. Requires
        // BE coordination to expose orderItemId -> conference resolution.
        await request({
            method: 'post',
            url: `/admin-api/conferences/${orderItemId()}/mark-no-show/`,
            data: { actor: noShowActor.value, notes: noShowNotes.value },
        });
        noShowOpen.value = false;
        onDone();
    } finally {
        busy.value = false;
    }
}

function onDone(): void {
    cancelOpen.value = false;
    rescheduleOpen.value = false;
    noShowOpen.value = false;
    window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn--danger",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelOpen.value = true))
    }, "Отменить личную сессию"),
    _createElementVNode("button", {
      class: "btn btn--primary",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (rescheduleOpen.value = true))
    }, "Перенести личную сессию"),
    _createElementVNode("button", {
      class: "btn",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (noShowOpen.value = true))
    }, "Отметить неявку"),
    (cancelOpen.value)
      ? (_openBlock(), _createBlock(CancelConsultationDialog, {
          key: 0,
          open: cancelOpen.value,
          "order-item-id": orderItemId,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (cancelOpen.value = false)),
          onDone: onDone
        }, null, 8, ["open"]))
      : _createCommentVNode("", true),
    (rescheduleOpen.value)
      ? (_openBlock(), _createBlock(RescheduleDialog, {
          key: 1,
          open: rescheduleOpen.value,
          "order-item-id": orderItemId,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (rescheduleOpen.value = false)),
          onDone: onDone
        }, null, 8, ["open"]))
      : _createCommentVNode("", true),
    (noShowOpen.value)
      ? (_openBlock(), _createElementBlock("dialog", {
          key: 2,
          open: noShowOpen.value,
          class: "action-dialog"
        }, [
          _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Отметить неявку", -1)),
          _createElementVNode("label", null, [
            _cache[9] || (_cache[9] = _createTextVNode("Кто не явился ")),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((noShowActor).value = $event))
            }, _cache[8] || (_cache[8] = [
              _createElementVNode("option", { value: "mentor" }, "Наставник", -1),
              _createElementVNode("option", { value: "mentee" }, "Ученик", -1)
            ]), 512), [
              [_vModelSelect, noShowActor.value]
            ])
          ]),
          _createElementVNode("label", null, [
            _cache[10] || (_cache[10] = _createTextVNode("Примечания ")),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((noShowNotes).value = $event)),
              rows: "3"
            }, null, 512), [
              [_vModelText, noShowNotes.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn btn--primary",
              disabled: busy.value,
              onClick: submitNoShow
            }, _toDisplayString(busy.value ? 'Отправляю…' : 'Отметить'), 9, _hoisted_4),
            _createElementVNode("button", {
              class: "btn",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (noShowOpen.value = false))
            }, "Отмена")
          ])
        ], 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})